import styled from 'styled-components';

import { DIRECTION } from '@/types/common';

export const ArrowSVG = styled.svg<{ direction: DIRECTION }>`
  transition: transform 0.1s linear;
  transform: rotate(
    ${({ direction }) =>
      direction === DIRECTION.TOP
        ? 90
        : direction === DIRECTION.BOTTOM
        ? -90
        : direction === DIRECTION.LEFT
        ? 180
        : 0}deg
  );
`;
